import React, { Component } from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Home from "./pages/Home";
import Duvidas from "./pages/Duvidas";
import Formulario from "./pages/Formulario";
import Dashboard from "./pages/Dashboard";
import AdminIndex from "./pages/Admin/Index";
import AdminDashboard from "./pages/Admin/Dashboard";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Aux from "./components/hoc/Aux";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./assets/css/halfslider.css";
import "./assets/css/material-icons.min.css";
import "./assets/css/animate.min.css";

const Admin = (props) => {
  const { path } = props.match;

  return (
    <Switch>
      <Route exact path={path} component={AdminIndex} />
      <Route path={`${path}/dashboard`} component={AdminDashboard} />
    </Switch>
  );
};

class App extends Component {
  render() {
    return (
      <Router basename={process.env.REACT_APP_BASE_NAME}>
        <Aux>
          <Header />
          <Route exact path="/" component={Home} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/formulario" component={Formulario} />
          <Route path="/duvidas" component={Duvidas} />
          <Route path="/admin" component={Admin} />
          <Footer />
        </Aux>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js